import { toast, ToastPosition } from "react-toastify";
import "../index.css";

export const successToast = (
  msg: string,
  position: ToastPosition | undefined = undefined,
  autoClose: number = 0,
  className?: string
) =>
  toast.success(msg, {
    autoClose: autoClose || 2000,
    hideProgressBar: true,
    theme: "colored",
    position: position || "top-right",
    closeButton: true,
    className: "success-toast " + className || "success-toast",
  });

export const errorToast = (msg: string) =>
  toast.error(msg, {
    autoClose: 2000,
    hideProgressBar: true,
    theme: "colored",
  });
